import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=63d4aa7e&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=ts&"
export * from "./Button.vue?vue&type=script&lang=ts&"
import style0 from "./Button.vue?vue&type=style&index=0&id=63d4aa7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4aa7e",
  null
  
)

export default component.exports